import type React from 'react';
import { type FunctionComponent, useContext } from 'react';

import type { Features } from '../../features';

import { FeaturesContext } from './FeatureFlagProvider';

interface Props {
  showIf: keyof Features;
  children?: React.ReactNode;
}

export const FeatureFlag: FunctionComponent<Props> = ({ showIf, children }) =>
  useFeatureFlag(showIf) ? <>{children}</> : null;

export const useFeatureFlag = (
  feature: keyof Features,
  fallback: boolean = false,
): boolean => {
  const context = useContext(FeaturesContext);
  return context[feature] ?? fallback;
};
